// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"B7-z"};